import { getFileAttachment } from "../../api/secure-messaging-api";
import translate from "../../constants/translations";
import type { Attachment, CustomerContext } from "../../types";

interface FileAttachmentProps {
	cultureCode: string;
	customer: CustomerContext;
	attachment: Attachment;
}

export default function FileAttachment({
	cultureCode,
	customer,
	attachment,
}: FileAttachmentProps) {
	const t = (term: string) => translate(cultureCode, term);

	const onGetAttachmentClick = async () => {
		const blob = await getFileAttachment(customer, attachment.attachmentId);
		if (!blob) {
			return;
		}

		const nav = window.navigator as Navigator & {
			msSaveOrOpenBlob?: (blobData: Blob, defaultName?: string) => void;
		};

		if (nav.msSaveOrOpenBlob) {
			nav.msSaveOrOpenBlob(blob, attachment.name);
			return;
		}

		const downloadFile = (objectUrl: string) => {
			const downloadLink = document.createElement("a");
			downloadLink.href = objectUrl;
			downloadLink.download = attachment.name;
			downloadLink.rel = "noopener noreferrer";
			downloadLink.click();
			window.URL.revokeObjectURL?.(objectUrl);
		};

		if (nav.userAgent.toLowerCase().includes("if mobile")) {
			// Webview cannot read blobs, so the blob needs to be converted to a base64string
			const reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onload = () => {
				downloadFile(reader.result as string);
			};
		} else {
			downloadFile(window.URL.createObjectURL(blob));
		}
	};

	return (
		<div
			className="mypages-message-attachment"
			style={{ paddingLeft: 0, gap: "0.5rem" }}
		>
			{attachment.status === "Handled" && (
				<>
					<div
						className="mypages-message-attachment__icon"
						style={{ width: "24px", height: "24px", flexShrink: 0 }}
					></div>
					<button
						type="button"
						className="if button text mypages-message-attachment__link"
						title={attachment.name}
						style={
							{
								maxWidth: "calc(100% - 40px)",
								width: "auto",
								padding: "0.25rem 0",
								display: "inline-block",
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
							} as any
						}
						onClick={onGetAttachmentClick}
					>
						{attachment.name}
					</button>
				</>
			)}

			{attachment.status === "New" && (
				<div className="mypages-message-attachment__file mypages-message-attachment__file--in-progress">
					<span>{attachment.name}</span>
					<span> - </span>
					<span>{t("AttachmentScanInProgressText")}</span>
				</div>
			)}

			{attachment.status === "Rejected" && (
				<div className="mypages-message-attachment__file mypages-message-attachment__file--failed">
					<span>{attachment.name}</span>
					<span> - </span>
					<span>{t("AttachmentScanRejectedText")}</span>
				</div>
			)}
		</div>
	);
}
